<div class="layout-wrapper-view" *ngIf="menuCategories$ | async as categories">
  <xm-menu-categories *ngIf="!isGuestLayout && !isMobileScreen"></xm-menu-categories>
  <mat-sidenav-container class="menu-sidenav-container" [hasBackdrop]="isMobileScreen" [@.disabled]="!isMaterial3Menu && !isMobileScreen">
    <mat-sidenav #sidenav
                 [ngClass]="{
                        'menu-sidenav': isMaterial3Menu,
                        'border-none': !categories?.length,
                        'no-box-shadow': sidenav.mode === 'push'
                     }"
                 [mode]="'side'"
                 [opened]="false"
                 [fixedInViewport]="!isMobileScreen"
                 [autoFocus]="false"
    >
      <xm-sidebar *ngIf="!isGuestLayout && !isSidebarHidden"></xm-sidebar>
    </mat-sidenav>
    <mat-sidenav-content class="menu-sidenav-container__content">
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <xm-dynamic-widget-layout *ngIf="mainLayout" [layouts]="mainLayout"></xm-dynamic-widget-layout>
</div>
